type HexColor = `#${string}`;
type Colors = {
  primary: HexColor;
  primaryHover: HexColor;
  primaryActive: HexColor;
  transparent: HexColor;
  secondary: HexColor;
  white: HexColor;
};

export const BASIC_ORANGE = '#F8931F';
export const DARK_ORANGE = '#9C4E13';
export const LIGHT_ORANGE = '#F3D2AC';
export const DARK_GREEN = '#026431';
export const FOREST_GREEN = '#217D4E';
export const SAGE_GREEN = '#53A47B';
export const LIGHT_MINT = '#EAF3EF';
export const CHARCOAL_BLACK = '#111413';
export const MEDIUM_GRAY = '#525252';
export const SILVER_GRAY = '#9F9F9F';
export const LIGHT_SILVER = '#C2C2C2';
export const EXTRA_LIGHT_GRAY = '#EDEDED';
export const BASIC_WHITE = '#FFFFFF';
export const TRANSPARENT = '#00000000';

export const colors: Colors = {
  primary: DARK_GREEN,
  primaryHover: BASIC_ORANGE,
  primaryActive: DARK_ORANGE,
  transparent: TRANSPARENT,
  secondary: MEDIUM_GRAY,
  white: BASIC_WHITE,
};

export default colors;
